"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlertPreviewViewItems = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Tag_1 = require("../../../components/Tag");
const AlertNotificationWizardSection_1 = require("../../../View/Alert/Wizard/AlertNotificationWizardSection");
const getAlertPreviewViewItems = (alert, api) => {
    return {
        name: 'Type and Display',
        view: () => {
            var _a;
            if (!((_a = alert === null || alert === void 0 ? void 0 : alert.AlertProperties) === null || _a === void 0 ? void 0 : _a.DisplayNotification)) {
                return React.createElement(Tag_1.Tag, null, alert.MessageType);
            }
            return (React.createElement(AlertNotificationWizardSection_1.AlertPreview, { focusFirstButton: false, style: { maxWidth: 400 }, mt: 2, api: api, alertDefinition: alert }));
        },
    };
};
exports.getAlertPreviewViewItems = getAlertPreviewViewItems;
